import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import {
  useDeleteAdminMutation,
  useEditAdminMutation,
  useGetAdminsQuery,
} from "../../store/Api/admins";
import { hidetoast, useDecodeToken } from "../../Utils/function";
import { useGetRrbQuery } from "../../store/Api/common";
import {
  useDeleteSupportTicketMutation,
  useEditSupportTicketMutation,
} from "../../store/Api/supportTicket";
import ReAuditsUi from "./ReAuditsUi";
import {
  useEditReAuditMutation,
  useGetReAuditQuery,
} from "../../store/Api/reAudits";
import { useDispatch, useSelector } from "react-redux";
import  {rowsPerPage} from '../../Utils/constant'

function ReAudits() {
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState("");
  const decodedToken = useDecodeToken();
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
  });
  const [updateData, setUpDateData] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [viewReAudit, setViewReAudit] = useState(false);
  const [viewReAuditData, setViewReAuditData] = useState({});
  const [deleteAuditQuestion] = useDeleteSupportTicketMutation();
  const [updateAuditQuestion] = useEditSupportTicketMutation();
  const [updateReAudit] = useEditReAuditMutation();
  const [rowData, setRowData] = useState("");
  const { data, isFetching, isLoading, refetch } = useGetReAuditQuery({
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
  });
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
  useEffect(() => {
    if (toast.message) {
      hidetoast();
    }
  }, [toast.message, dispatch]);
  const onUpdate = async (row) => {
    navigate(`/update-audit-question/${row?.id}`, { state: { row } });
  };
  const onView = async (row) => {
    navigate(`/view-audit-question/${row?.id}`, { state: { row } });
  };
  const handleCloseModal = () => {
    setShowForm(false);
  };
  const handleSubmit = async (values, { resetForm }) => {
    const formData = {
      // ...updateData,
      status: updateData?.status,
      ...values,
    };
    try {
      const response = await updateReAudit({
        id: updateData?.id,
        formData,
      });
      if (response?.data?.success) {
        setUpDateData("");
        setShowForm(false);
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  const handleApprove = async () => {
    const formData = {
      // // ...updateData,
      // status: updateData?.status,
      status: "approved",
    };
    try {
      const response = await updateReAudit({
        id: rowData?.id,
        formData,
      });
      if (response?.data?.success) {
        setUpDateData("");
        setShowForm(false);
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };

  const deleteFn = async () => {
    try {
      const response = await deleteAuditQuestion({ id: deleteId });
      if (response?.data?.success) {
        // Call refetch to refresh the user list
        refetch();
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };
  const truncateText = (text, wordLimit) => {
    const words = text?.split(" ") || [];
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };
  const handleCloseViewModal = () => {
    setViewReAudit(false);
  };
  const columns = [
    ...(decodedToken?.role === 3 || decodedToken?.role === 4
      ? [{ title: "RRB", render: (_, row) => row?.audits?.rrb?.name || "-" }]
      : []),
    // { title: "Date", dataKey: "audit_date" },
    // {
    //   title: "Date",
    //   dataKey: "audit_date",
    //   render: (audit_date) => {
    //     if (!audit_date) return "N/A";
    //     const date = new Date(audit_date);
    //     const day = String(date.getDate()).padStart(2, "0");
    //     const month = String(date.getMonth() + 1).padStart(2, "0");
    //     const year = date.getFullYear();
    //     return `${day}-${month}-${year}`;
    //   },
    // },
    ...(decodedToken?.role != 5
      ? [
          {
            title: "Auditor", // Single column for full name
            render: (_, row) =>
              `${row.user?.firstname || ""} ${
                row.user?.lastname || ""
              }`.trim() || "N/A",
          },
        ]
      : []),
    {
      title: "Center",
      render: (_, row) => row?.audits?.centre?.name || "-",
    },
    {
      title: "Auditor Reason",
      render: (_, row) => (
        <div
          style={{
            maxWidth: "200px",
            whiteSpace: "normal",
            overflowWrap: "break-word",
          }}
        >
          {truncateText(row?.reason || "-", 50)}
        </div>
      ),
    },
    {
      title: "Admin Reason",
      render: (_, row) => (
        <div
          style={{
            maxWidth: "200px",
            whiteSpace: "normal",
            overflowWrap: "break-word",
          }}
        >
          {truncateText(row?.admin_reason || "-", 50)}
        </div>
      ),
    },
    // { title: "Status", dataKey: "status" },
    ...(decodedToken?.role != 5
      ? [
          {
            title: "Status",
            // dataKey: "status",
            render: (_, row) => {
              let status = row?.status;
              const getBadgeColor = (row) => {
                switch (status) {
                  case "approved":
                    return " bg-approved_theame text-white";
                  case "rejected":
                    return "bg-rejected_theame text-white";
                  default:
                    return "bg-secondary text-white"; // Default gray badge for other statuses
                }
              };

              return (
                <div className="d-flex justify-content-center">
                <span
                  className={`badge ${getBadgeColor(status)}`}
                  style={{ padding: "8px 5px" }}
                >
                  {status.charAt(0).toUpperCase() + status.slice(1)}
                </span>
                </div>
              );
            },
          },
        ]
      : []),

    {
      title: "Actions",
      render: (_, row) => (
        <div className="d-flex">
          <button
            className="border-0 bg-transparent"
            onClick={() => {
              setViewReAuditData(row);
              setViewReAudit(true);
            }}
          >
            <i class="fas fa-eye text-primary"></i>
          </button>
          {row?.status == "pending" ? (
            <>
              <button
                className="border-0 bg-transparent"
                type="button"
                data-toggle="modal"
                data-target="#modal-danger"
                onClick={() => {
                  // handleApprove(row);
                  setRowData(row);
                  // setUpDateData({ ...row, status: "approved" });
                  // setShowForm(true);
                }}
              >
                <i class="fas fa-check text-success"></i>
              </button>
              <button
                className="border-0 bg-transparent"
                type="button"
                onClick={() => {
                  setUpDateData({ ...row, status: "rejected" });
                  setShowForm(true);
                }}
              >
                <i class="fas fa-window-close text-danger"></i>
              </button>
            </>
          ) : null}
        </div>
      ),
    },
  ];

  return (
    <Layout>
      <ReAuditsUi
        columns={columns}
        data={data?.data?.data || []}
        // data={[]}
        totalRecords={data?.data?.totalItems}
        onUpdate={onUpdate}
        loading={isLoading}
        tableQaury={tableQaury}
        handleApprove={handleApprove}
        onPageChange={handlePageChange}
        setTableQaury={setTableQaury}
        decodedToken={decodedToken}
        showForm={showForm}
        setShowForm={setShowForm}
        handleSubmit={handleSubmit}
        handleCloseModal={handleCloseModal}
        updateData={updateData}
        viewReAudit={viewReAudit}
        handleCloseViewModal={handleCloseViewModal}
        viewReAuditData={viewReAuditData}
        toast={toast}
      />
    </Layout>
  );
}

export default ReAudits;
